(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('office-phone', {
            parent: 'entity',
            /*
            url: '/office-phone?page&sort&search',
            */
            url: '/office-phone?page&sort&search&actualFilter',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.officePhone.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/office-phone/office-phones.html',
                    controller: 'OfficePhoneController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                actualFilter: {
                    value: 'true',
                    squash: true
                },
                sort: {
                    /*
                    value: 'id,asc',
                    */
                    value: 'number,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        actualFilter: $stateParams.actualFilter,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('officePhone');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('office-phone-detail', {
            parent: 'office-phone',
            url: '/office-phone/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.officePhone.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/office-phone/office-phone-detail.html',
                    controller: 'OfficePhoneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('officePhone');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'OfficePhone', function($stateParams, OfficePhone) {
                    return OfficePhone.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'office-phone',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('office-phone-detail.edit', {
            parent: 'office-phone-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/office-phone/office-phone-dialog.html',
                    controller: 'OfficePhoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OfficePhone', function(OfficePhone) {
                            return OfficePhone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('office-phone.new', {
            parent: 'office-phone',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/office-phone/office-phone-dialog.html',
                    controller: 'OfficePhoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                name: null,
                                caption: null,
                                number: null,
                                /*
                                actual: false,
                                */
                                short_number: null,
                                actual: true,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('office-phone', null, { reload: 'office-phone' });
                }, function() {
                    $state.go('office-phone');
                });
            }]
        })
        .state('office-phone.edit', {
            parent: 'office-phone',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/office-phone/office-phone-dialog.html',
                    controller: 'OfficePhoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OfficePhone', function(OfficePhone) {
                            return OfficePhone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('office-phone', null, { reload: 'office-phone' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('office-phone.delete', {
            parent: 'office-phone',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/office-phone/office-phone-delete-dialog.html',
                    controller: 'OfficePhoneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['OfficePhone', function(OfficePhone) {
                            return OfficePhone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('office-phone', null, { reload: 'office-phone' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
